export enum LoyaltyType {
  PIGGY = 'piggy',
  COMO = 'como',
  INTERNAL = 'internal',
  RBI = 'rbi',
}
